import { useState, useEffect } from 'react';
import React from 'react';

function ImageUploadSection({ title, Picture, onPictureChange, isRequired }) {
  const [image, setImage] = useState(null);  
  const [inputKey, setInputKey] = React.useState(Date.now());

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      //onPictureChange(URL.createObjectURL(file));
      setImage(URL.createObjectURL(file));
      
 // Convert to Base64
      const reader = new FileReader();
      reader.onloadend = () => {
        onPictureChange(reader.result); // Store Base64 string in state
      };
      reader.readAsDataURL(file);

    }
  };

  const handleRemove = (event) => {
    event.preventDefault();
    setImage(null);
    setInputKey(Date.now());
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file) {
      //onPictureChange
      onPictureChange(URL.createObjectURL(file));
      setImage(URL.createObjectURL(file));
    }
  };

  const handlePaste = (event) => {
    const items = event.clipboardData.items;
    for (let item of items) {
      if (item.type.indexOf('image') !== -1) {
        const blob = item.getAsFile();
        onPictureChange(URL.createObjectURL(blob));
        setImage(URL.createObjectURL(blob));
        break;
      }
    }
  };

  


  return (
    <div className="upload-section" onDrop={handleDrop} onPaste={handlePaste}>
      <div className="info-hover-wrapper" style={{backgroundColor:"gray",color:"white",width:'100%',padding:'2%'}}>
      <div className="hover-target">{title} {isRequired? <label style={{ color: 'red',fontSize: "21px" }}>*</label>:""} <span className="circle-info-icon info-icon" style={{float:'right'}}>i</span></div>
      <img src={Picture} alt={title} className="hover-image" />      
      </div>
      <br/>
      <br/>
      <div className="buttons">
        <label className="load-button">
          📤 Load
          <input key={inputKey} type="file" accept="image/*" onChange={handleImageUpload} hidden />
        </label>&nbsp;&nbsp;&nbsp;
        <button className="remove-button" onClick={handleRemove}>🗑️ Remove</button>
      </div>
      <div className="drop-area">        
        {image ? <img src={image} alt="Uploaded" width="90%" height="400"/> : <p>drop or paste picture here</p>}
      </div>
    </div>
  );
}

export default ImageUploadSection;